const LoginConfig = {
    LoginRouterOKUrl: '/homeCom/HomePage?NodeID=60', //配置登录成功后跳转路由地址
    LoginRouterOKUrlTemporary: '/homeCom/CompanyIinformation?NodeID=61' //配置登录成功后跳转路由地址(临时账号)
}
export default LoginConfig;
